import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'
import * as routes from 'core/routing/constants/index'
import styled from 'styled-components'
import { isMobile, isTablet } from 'react-device-detect'
import ZipCodeInput from 'core/components/ui/inputTypeNumber'
import {
  Radio,
  ButtonLink,
  RadioButton,
  Input,
  Row,
  Col,
  Checkbox,
  Form,
  Select
} from 'core/components/ui'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import TitleIcon from 'core/layouts/title-icon'
import applicationOptionType from 'core/utils/enums/applicationOptions'
import PhoneInput from 'react-phone-number-input'
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input/max'
import en from 'react-phone-number-input/locale/en.json'
import fr from 'react-phone-number-input/locale/fr.json'
import { font, greys, borderRadius, fontFamily } from 'assets/themes/theme-default'
import { calculateAlphaColor } from 'core/utils/colors'
import { tradeInShape } from '../shapes'

const StyledPhoneInput = styled(PhoneInput)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  padding: 0 11px;
  color: ${greys.dark1};
  border-radius: ${borderRadius.sm};
  border: 1px solid ${greys.dark4};
  background: #fff;
  :hover {
    border-color: ${props => props.theme.colors.color1.bg};
  }
  :focus-within {
    border-color: ${props => props.theme.colors.color1.bg};
    box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
  }
  > input {
    flex: 1;
    min-width: 0;
    background: transparent;
    border: none;
    outline: none;
  }
`

const Legend2 = styled.div`
  background: ${greys.light3};
  border-radius: ${borderRadius.base};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`}
    ${fontFamily.italic};
  padding: 20px;
  font-size: ${font.size.base};
  a {
    color: ${props => props.theme.colors.color1.bg};
  }
`

const SelectCivility = styled(Select)`
  &&& {
    margin-bottom: ${isMobile ? '15px' : '0'};

    width: 100%;
    .ant-select-arrow {
      background: none;
      color: ${props => props.theme.colors.color1.bg};
    }
    .ant-select-selection__clear {
      right: 42px;
    }
  }
`

const InputLastName = styled(Input)`
  text-transform: uppercase;
`
const InputFirstName = styled(Input)`
  text-transform: capitalize;
`

const InputWrapper = styled(Row)`
  margin: 5px 0;
`
const CheckboxRow = styled(Row)`
  margin: 20px 0 0px;
`
const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const InterTitle = styled.h3`
  font-size: ${font.size.lg};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
  color: ${greys.dark1};
`

const { TextArea } = Input

const inputsId = {
  q1: 1,
  q2: 2,
  q3: 3,
  q4: 4,
  q5: 5,
  q6: 6,
  q7: 7,
  q8: 8,
  q9: 9,
  q10: 10
}

const Distributor = props => {
  const {
    intl,
    setWizards,
    tradeIn,
    setTradeIn,
    wizards,
    history,
    form,
    campaign,
    privacyPolicy,
    applicationOptions
  } = props

  const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = form

  const { pointOfSales, user, futherInformations, comment } = tradeIn
  const aStepsActive = wizards[wizards.activeWizard]

  const [showConsent, setShowConsent] = useState(false)

  const { phoneRequired } = campaign

  // let fundingValue
  let purchaseValue

  if (futherInformations) {
    //fundingValue = futherInformations.funding
    purchaseValue = futherInformations.purchase && futherInformations.purchase.value
  }

  const keyTradeInFurtherInformationsPurchase = intl.formatMessage({
    id: 'tradeIn-futher-informations-question-2-label'
  })

  const handleChangeInfomations = (questionId, value) => {
    let extendedFutherInformations = futherInformations
    let commentCampaign = comment

    switch (questionId) {
      case inputsId.q9:
        extendedFutherInformations = {
          ...futherInformations,
          purchase: {
            key: keyTradeInFurtherInformationsPurchase,
            value
          }
        }
        break
      case inputsId.q10:
        commentCampaign = value
        break
      default:
        break
    }
    setTradeIn({
      ...tradeIn,
      comment: commentCampaign,
      futherInformations: extendedFutherInformations
    })
  }

  const handleChangeUser = (inputId, value) => {
    let extendedUser
    switch (inputId) {
      case inputsId.q1:
        extendedUser = {
          ...user,
          civility: value
        }
        break
      case inputsId.q2:
        extendedUser = {
          ...user,
          lastName: value
        }
        break
      case inputsId.q3:
        extendedUser = {
          ...user,
          firstName: value
        }
        break
      case inputsId.q4:
        extendedUser = {
          ...user,
          email: value
        }
        break
      case inputsId.q5:
        extendedUser = {
          ...user,
          zipCode: value
        }
        break
      case inputsId.q6:
        if (value && isValidPhoneNumber(value)) {
          const phone = parsePhoneNumber(value)
          extendedUser = {
            ...user,
            phoneNumber: phone.nationalNumber,
            phoneNumberPrefixCode: `+${phone.countryCallingCode}`,
            isCellphone: phone.getType() === 'MOBILE'
          }
        } else {
          extendedUser = {
            ...user
          }
        }
        break
      case inputsId.q7:
        {
          const newValue = user && user.marketingConsent && user.marketingConsent === 1 ? 0 : 1
          extendedUser = {
            ...user,
            marketingConsent: newValue
          }
        }
        break
      case inputsId.q8:
        {
          const newValue = user && user.thirdConsent && user.thirdConsent === 1 ? 0 : 1
          extendedUser = {
            ...user,
            thirdConsent: newValue
          }
        }
        break
      default:
        break
    }

    setTradeIn({
      ...tradeIn,
      user: extendedUser
    })
  }

  const activateNextStep = () => {
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_CONTACT) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  const desactivateNextStep = () => {
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_CONTACT) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  const capitalize = s => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const requiredRule = {
    required: true,
    message: <FormattedMessage id="ui-input-requieredField" />
  }

  const requiredRulePhone = phoneRequired ? requiredRule : {}

  const hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field])

  useEffect(() => {
    if (purchaseValue !== undefined && !hasErrors(getFieldsError())) {
      activateNextStep()
    } else {
      desactivateNextStep()
    }
  }, [purchaseValue, hasErrors(getFieldsError())])

  useEffect(() => {
    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_CONTACT)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }
  }, [])

  useEffect(() => {
    // To disable submit button at the beginning.
    form.validateFields()
  }, [])

  useEffect(() => {
    setShowConsent(
      pointOfSales &&
        privacyPolicy &&
        Array.isArray(applicationOptions) &&
        applicationOptions.includes(applicationOptionType.CONSENTS)
    )
  }, [])

  // Only show error after a field is touched.
  const genderError = isFieldTouched('gender') && getFieldError('gender')
  const lastNameError = isFieldTouched('lastName') && getFieldError('lastName')
  const firstNameError = isFieldTouched('firstName') && getFieldError('firstName')
  const emailError = isFieldTouched('email') && getFieldError('email')
  const zipCodeError = isFieldTouched('zipCode') && getFieldError('zipCode')

  function createConsent() {
    return { __html: campaign.theme.header.consent.html }
  }

  return (
    <MainContentWrapper>
      <TitleIcon
        title={intl.formatMessage({
          id: 'tradeIn-contact-subTitle'
        })}
      />
      <Form>
        <Row type="flex" justify="center" gutter={32}>
          <Col lg={showConsent ? 12 : 14} sm={10} xs={24}>
            <InputWrapper type="flex" gutter={12}>
              <Col span={isMobile && !isTablet ? 24 : 12}>
                <Form.Item
                  // style={{ margin: 0 }}
                  validateStatus={genderError ? 'error' : ''}
                  help={genderError || ''}
                  key="gender"
                >
                  {getFieldDecorator('gender', {
                    initialValue: user && user.civility
                  })(
                    <SelectCivility
                      onChange={value => handleChangeUser(inputsId.q1, value)}
                      allowClear
                      placeholder={intl.formatMessage({
                        id: 'tradeIn-contact-civility-placeholder'
                      })}
                    >
                      {[
                        {
                          value: 2,
                          label: <FormattedMessage id="tradeIn-contact-civility-reply-1" />
                        },
                        {
                          value: 1,
                          label: <FormattedMessage id="tradeIn-contact-civility-reply-2" />
                        }
                      ].map(item => (
                        <SelectCivility.Option
                          value={item.value}
                          key={item.value}
                          label={item.label}
                        >
                          {item.label}
                        </SelectCivility.Option>
                      ))}
                    </SelectCivility>
                  )}
                </Form.Item>
              </Col>
            </InputWrapper>
            <InputWrapper type="flex" justify="center" gutter={12}>
              <Col span={isMobile && !isTablet ? 24 : 12}>
                <Form.Item
                  validateStatus={lastNameError ? 'error' : ''}
                  help={lastNameError || ''}
                  key="lastName"
                >
                  {getFieldDecorator('lastName', {
                    initialValue: user && user.lastName,
                    rules: [requiredRule]
                  })(
                    <InputLastName
                      placeholder={intl.formatMessage({
                        id: 'tradeIn-contact-input-1-palceholder'
                      })}
                      onChange={e => handleChangeUser(inputsId.q2, e.target.value.toUpperCase())}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={isMobile && !isTablet ? 24 : 12}>
                <Form.Item
                  validateStatus={firstNameError ? 'error' : ''}
                  help={firstNameError || ''}
                  key="firstName"
                >
                  {getFieldDecorator('firstName', {
                    initialValue: user && user.firstName,
                    rules: [requiredRule]
                  })(
                    <InputFirstName
                      placeholder={intl.formatMessage({
                        id: 'tradeIn-contact-input-2-palceholder'
                      })}
                      onChange={e => handleChangeUser(inputsId.q3, capitalize(e.target.value))}
                    />
                  )}
                </Form.Item>
              </Col>
            </InputWrapper>
            <InputWrapper type="flex" justify="center" gutter={12}>
              <Col span={24}>
                <Form.Item
                  validateStatus={emailError ? 'error' : ''}
                  help={emailError || ''}
                  key="email"
                >
                  {getFieldDecorator('email', {
                    initialValue: user && user.email,
                    rules: [
                      requiredRule,
                      {
                        type: 'email',
                        message: intl.formatMessage({
                          id: 'tradeIn-contact-input-3-palceholder-error'
                        })
                      }
                    ]
                  })(
                    <Input
                      placeholder={intl.formatMessage({
                        id: 'tradeIn-contact-input-3-palceholder'
                      })}
                      onChange={e => handleChangeUser(inputsId.q4, e.target.value)}
                    />
                  )}
                </Form.Item>
              </Col>
            </InputWrapper>
            <InputWrapper type="flex" justify="center" gutter={12}>
              <Col lg={12} xs={16}>
                <Form.Item key="telephone">
                  {getFieldDecorator('telephone', {
                    initialValue:
                      user &&
                      user.phoneNumberPrefixCode &&
                      user.phoneNumber &&
                      `${user.phoneNumberPrefixCode}${user.phoneNumber}`,
                    rules: [
                      requiredRulePhone,
                      {
                        message: <FormattedMessage id="tradeIn-contact-input-5-rules" />,
                        validator: async (_, value) => {
                          if (value) {
                            const phone = parsePhoneNumber(value)
                            if (phone.nationalNumber && !isValidPhoneNumber(value))
                              throw new Error()
                          }
                        }
                      }
                    ]
                  })(
                    <StyledPhoneInput
                      international
                      className="ant-input"
                      defaultCountry={campaign.lang.substr(3)}
                      labels={campaign.lang.substr(3) === 'FR' ? fr : en}
                      countryCallingCodeEditable={false}
                      name="cellphone"
                      onChange={value => handleChangeUser(inputsId.q6, value)}
                      maxLength={25}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col lg={12} xs={8}>
                <Form.Item
                  validateStatus={zipCodeError ? 'error' : ''}
                  help={zipCodeError || ''}
                  key="zipCode"
                >
                  {getFieldDecorator('zipCode', {
                    initialValue: user && user.zipCode
                    /* rules: [
                      requiredRule,
                      {
                        pattern: RegExp(/^(([0-8][0-9])|(9[0-5]))[0-9]{3}$/),
                        message: <FormattedMessage id="ui-input-zipcode-invalid" />
                      }
                    ]*/
                  })(
                    <ZipCodeInput
                      placeholder={intl.formatMessage({
                        id: 'tradeIn-contact-input-4-palceholder'
                      })}
                      onChange={e => handleChangeUser(inputsId.q5, e)}
                    />
                  )}
                </Form.Item>
              </Col>
            </InputWrapper>

            <InputWrapper type="flex">
              <Col span={24}>
                <InterTitle>
                  <FormattedMessage id={keyTradeInFurtherInformationsPurchase} />
                </InterTitle>
                <InputWrapper type="flex">
                  <Col span={24}>
                    <Radio.Group
                      buttonStyle="solid"
                      value={purchaseValue}
                      onChange={e => handleChangeInfomations(inputsId.q9, e.target.value)}
                    >
                      <RadioButton
                        value={intl.formatMessage({
                          id: 'tradeIn-futher-informations-question-2-reply-1'
                        })}
                      >
                        <FormattedMessage id="tradeIn-futher-informations-question-2-reply-1" />
                      </RadioButton>
                      <RadioButton
                        value={intl.formatMessage({
                          id: 'tradeIn-futher-informations-question-2-reply-2'
                        })}
                      >
                        <FormattedMessage id="tradeIn-futher-informations-question-2-reply-2" />
                      </RadioButton>
                      <RadioButton
                        value={intl.formatMessage({
                          id: 'tradeIn-futher-informations-question-2-reply-3'
                        })}
                      >
                        <FormattedMessage id="tradeIn-futher-informations-question-2-reply-3" />
                      </RadioButton>
                    </Radio.Group>
                  </Col>
                </InputWrapper>
              </Col>
            </InputWrapper>

            <InputWrapper type="flex">
              <Col span={24}>
                <InterTitle>
                  <FormattedMessage id="tradeIn-comment-1" />
                </InterTitle>
                <InputWrapper type="flex">
                  <Col span={24}>
                    <Form.Item key="comment">
                      {getFieldDecorator('comment', {
                        initialValue: comment
                      })(
                        <TextArea
                          name="comment"
                          autosize={{ minRows: 4 }}
                          maxLength={500}
                          placeholder={intl.formatMessage({ id: 'tradeIn-comment-2' })}
                          onChange={e => handleChangeInfomations(inputsId.q10, e.target.value)}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </InputWrapper>
              </Col>
            </InputWrapper>
          </Col>

          {showConsent && (
            <Col lg={12} sm={14} xs={24}>
              <Legend2>
                {campaign &&
                campaign.theme &&
                campaign.theme.header &&
                campaign.theme.header.consent &&
                campaign.theme.header.consent.html ? (
                  /* eslint-disable-next-line react/no-danger */
                  <div dangerouslySetInnerHTML={createConsent()} />
                ) : (
                  <>
                    <FormattedMessage id="tradeIn-contact-legend-3" />
                    <br />
                    <FormattedMessage
                      id="tradeIn-contact-legend-2"
                      values={{
                        DPOName: privacyPolicy.entity
                          ? privacyPolicy.entity.name
                          : privacyPolicy.entityGroup.name
                      }}
                    />
                    {privacyPolicy.email ? (
                      <>
                        :{' '}
                        <ButtonLink
                          style={{ height: 'auto' }}
                          type="link"
                          href={`mailto: ${privacyPolicy.email}`}
                        >
                          {privacyPolicy.email}
                        </ButtonLink>
                      </>
                    ) : (
                      '.'
                    )}
                  </>
                )}
              </Legend2>

              <CheckboxRow type="flex" style={{ width: '100%' }} align="top" gutter={35}>
                <ColDataInput span={1}>
                  <Checkbox
                    checked={user && user.marketingConsent}
                    onClick={() => handleChangeUser(inputsId.q7, !user.marketingConsent)}
                  />
                </ColDataInput>
                <Col span={21}>
                  <FormattedMessage
                    id="tradeIn-contact-consent-1-label"
                    values={{
                      entityName: privacyPolicy.entity
                        ? privacyPolicy.entity.name
                        : privacyPolicy.entityGroup.name
                    }}
                  />
                </Col>
              </CheckboxRow>
              <CheckboxRow type="flex" style={{ width: '100%' }} align="top" gutter={35}>
                <ColDataInput span={1}>
                  <Checkbox
                    checked={user && user.thirdConsent}
                    onClick={() => handleChangeUser(inputsId.q8, !user.thirdConsent)}
                  />
                </ColDataInput>
                <Col span={21}>
                  <FormattedMessage
                    id="tradeIn-contact-consent-2-label"
                    values={{
                      entityName: privacyPolicy.entity
                        ? privacyPolicy.entity.name
                        : privacyPolicy.entityGroup.name
                    }}
                  />
                </Col>
              </CheckboxRow>
            </Col>
          )}
        </Row>
      </Form>
    </MainContentWrapper>
  )
}

Distributor.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  form: PropTypes.shape().isRequired,
  campaign: PropTypes.shape().isRequired,
  privacyPolicy: PropTypes.shape().isRequired,
  applicationOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired
}

export default withRouter(injectIntl(Form.create({ name: 'Contact' })(Distributor)))
